"use client";

import { createContext, useContext, type ReactNode } from "react";
import { site } from "@/config/site";
import { defaultLocale, type Locale } from "@/i18n/config";
import { apiErrorTexts, type ApiErrorTexts } from "@/i18n/dictionaries/api-error";

// İstemci bileşenleri için geçerli dil (kök düzen sağlar). Metinler bağlamla değil, prop olarak taşınır.
const LocaleContext = createContext<Locale>(defaultLocale);
// Site Yönetimi → İletişim'deki telefon: hata sınırı gibi sunucu verisi okuyamayan istemci bileşenleri için
const PhoneContext = createContext<string>(site.contact.phone);
// Site Yönetimi → Genel sayfa metinleri → Hata sayfası: hata sınırı (error.tsx) prop alamadığı için bağlamla
const ErrorTextsContext = createContext<ApiErrorTexts | null>(null);

export function LocaleProvider({ locale, phone, errorTexts, children }: { locale: Locale; phone?: string; errorTexts?: ApiErrorTexts; children: ReactNode }) {
  return (
    <LocaleContext value={locale}>
      <PhoneContext value={phone || site.contact.phone}>
        <ErrorTextsContext value={errorTexts ?? null}>{children}</ErrorTextsContext>
      </PhoneContext>
    </LocaleContext>
  );
}

export function useLocale(): Locale {
  return useContext(LocaleContext);
}

export function useSitePhone(): string {
  return useContext(PhoneContext);
}

/** Hata sayfası metinleri: panelden (kök düzen iletir); bağlam yoksa yerleşik metinler */
export function useErrorTexts(): ApiErrorTexts {
  const locale = useLocale();
  return useContext(ErrorTextsContext) ?? apiErrorTexts[locale];
}
